import Vue from "vue"
import { getCart } from "@/api/cart/index"
const User = {
  state: {
    total_item_num: 0
  },
  mutations: {
    SET_CART_TOTAL: (state, total_item_num) => {
      state.total_item_num = total_item_num
      Vue.ls.set("total_item_num", total_item_num)
    }
  },
  actions: {
    // 获取购物车数据
    getCartData({ commit }) {
      return new Promise(resolve => {
        getCart().then(response => {
          console.log(response)
          const result = response
          commit("SET_CART_TOTAL", result.total_item_num || 0)
          resolve(response)
        })
      })
    }
  }
}
export default User
